import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { formateDate, formateDateWithMonth } from "../../../../utils/commonfunction";
import * as userSubscriptionServices from "../../services/userSubscription.services";
import { useTranslation } from "react-i18next";

const UserSubscriptionView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    // { title: t("sidebar_link_subscribe"), url: "/admin/subscriptionManagement/list/1" },
    { title: t("sidebar_link_user_subscriptions"), url: "/admin/userSubscriptions/list/1" },
    { title: t("link_view"), url: "" },
  ];

  useEffect(() => {
    userSubscriptionServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <h6 className="main-content-label mb-3">
                {t("sidebar_link_user_subscriptions")}
              </h6>

              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">

                    {/* ── User Info ── */}
                    <h6 className="main-content-label mb-2 mt-3">User Info</h6>
                    <table className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>Name</th>
                          <td>
                            {showdefault?.user?.full_name ||
                              (showdefault?.user?.first_name
                                ? `${showdefault.user.first_name} ${showdefault.user.last_name || ""}`.trim()
                                : "N/A")}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_email")}</th>
                          <td>{showdefault?.user?.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("label_phone_number")}</th>
                          <td>
                            {showdefault?.user?.countryCode && showdefault?.user?.phone_number
                              ? `${showdefault.user.countryCode} ${showdefault.user.phone_number}`
                              : showdefault?.user?.phone_number || "N/A"}
                          </td>
                        </tr>
                        {showdefault?.user?.profile_image ? (
                          <tr>
                            <th>{t("label_profile_picture")}</th>
                            <td>
                              <img
                                src={showdefault.user.profile_image}
                                alt="profile"
                                style={{ height: "60px", width: "60px", borderRadius: "50%", objectFit: "cover" }}
                              />
                            </td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>

                    {/* ── Subscription Info ── */}
                    <h6 className="main-content-label mb-2 mt-3">Subscription Info</h6>
                    <table className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>{t("list_heading_title")}</th>
                          <td>{showdefault?.title || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_price")}</th>
                          <td>
                            {showdefault?.price !== null && showdefault?.price !== undefined
                              ? `$${showdefault.price}`
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>Paid Amount</th>
                          <td>
                            {showdefault?.paid_amount !== null && showdefault?.paid_amount !== undefined
                              ? `$${showdefault.paid_amount}`
                              : "N/A"}
                          </td>
                        </tr>
                        {showdefault?.credit_amount !== null && showdefault?.credit_amount !== undefined && showdefault.credit_amount > 0 ? (
                          <tr>
                            <th>Credit Amount</th>
                            <td>${showdefault.credit_amount}</td>
                          </tr>
                        ) : null}
                        <tr>
                          <th>{t("list_heading_duration_type")}</th>
                          <td className="text-capitalize">{showdefault?.duration_type || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Start Date</th>
                          <td>{showdefault?.start_date ? formateDateWithMonth(showdefault.start_date) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>End Date</th>
                          <td>{showdefault?.end_date ? formateDateWithMonth(showdefault.end_date) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>Status</th>
                          <td>
                            <span className={`badge ${showdefault?.activated ? "badge-success" : "badge-danger"}`}>
                              {showdefault?.activated ? "Active" : "Inactive"}
                            </span>
                          </td>
                        </tr>
                        <tr>
                          <th>Verified</th>
                          <td>
                            <span className={`badge ${showdefault?.verified ? "badge-success" : "badge-warning"}`}>
                              {showdefault?.verified ? "Yes" : "No"}
                            </span>
                          </td>
                        </tr>
                        {showdefault?.verified_at ? (
                          <tr>
                            <th>Verified At</th>
                            <td>{formateDateWithMonth(showdefault.verified_at)}</td>
                          </tr>
                        ) : null}
                        {showdefault?.platform ? (
                          <tr>
                            <th>Platform</th>
                            <td className="text-capitalize">{showdefault.platform}</td>
                          </tr>
                        ) : null}
                        {showdefault?.product_id ? (
                          <tr>
                            <th>Product ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.product_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.transaction_id ? (
                          <tr>
                            <th>Transaction ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.transaction_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.order_id ? (
                          <tr>
                            <th>Order ID</th>
                            <td style={{ wordBreak: "break-word" }}>{showdefault.order_id}</td>
                          </tr>
                        ) : null}
                        {showdefault?.subscription_state ? (
                          <tr>
                            <th>Subscription State</th>
                            <td className="text-capitalize">{showdefault.subscription_state}</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </table>

                    {/* ── Plan Info ── */}
                    {showdefault?.subscription_plan && Object.keys(showdefault.subscription_plan).length > 0 ? (
                      <>
                        <h6 className="main-content-label mb-2 mt-3">Plan Info</h6>
                        <table className="table table-bordered table-hover mb-4">
                          <tbody>
                            <tr>
                              <th style={{ width: "30%" }}>{t("list_heading_title")}</th>
                              <td>{showdefault.subscription_plan?.title || "N/A"}</td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_price")}</th>
                              <td>
                                {showdefault.subscription_plan?.price !== null &&
                                showdefault.subscription_plan?.price !== undefined
                                  ? `₹${showdefault.subscription_plan.price}`
                                  : "N/A"}
                              </td>
                            </tr>
                            <tr>
                              <th>{t("list_heading_duration_type")}</th>
                              <td className="text-capitalize">
                                {showdefault.subscription_plan?.duration_type || "N/A"}
                              </td>
                            </tr>
                            {showdefault.subscription_plan?.benefits?.length > 0 ? (
                              <tr>
                                <th>{t("label_benefits")}</th>
                                <td>{showdefault.subscription_plan.benefits.join(", ")}</td>
                              </tr>
                            ) : null}
                            {showdefault.subscription_plan?.subscription_access?.length > 0 ? (
                              <tr>
                                <th>{t("subscription_access")}</th>
                                <td>
                                  {showdefault.subscription_plan.subscription_access
                                    .map((a) => (a?.label && a?.value ? `${a.label}: ${a.value}` : a?.label || a?.value || ""))
                                    .filter(Boolean)
                                    .join(", ") || "N/A"}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      </>
                    ) : null}

                    {/* ── Subscription Access (snapshot) ── */}
                    {/* {showdefault?.subscription_access?.length > 0 ? (
                      <>
                        <h6 className="main-content-label mb-2 mt-3">{t("subscription_access")} (Snapshot)</h6>
                        <table className="table table-bordered table-hover mb-4">
                          <thead>
                            <tr>
                              <th>Label</th>
                              <th>Key</th>
                              <th>Value</th>
                            </tr>
                          </thead>
                          <tbody>
                            {showdefault.subscription_access.map((access, i) => (
                              <tr key={i}>
                                <td>{access?.label || "N/A"}</td>
                                <td>{access?.key || "N/A"}</td>
                                <td>{access?.value !== undefined ? String(access.value) : "N/A"}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : null} */}

                    {/* ── Timestamps ── */}
                    <table className="table table-bordered table-hover mb-4">
                      <tbody>
                        <tr>
                          <th style={{ width: "30%" }}>{t("Created Date")}</th>
                          <td>{showdefault?.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>

                    <div className="mt-3">
                      <button
                        className="btn ripple btn-dark"
                        type="button"
                        onClick={() => navigate(-1)}
                      >
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserSubscriptionView;
